export default __webpack_public_path__ + "static/media/ia-logo.32059b0b.png";